/**
 * servicing eapi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 購入
 */
export interface GetOrderResponseDataOrderEligibilitiesPayment {
  /**
   * 案内要否<br/> 以下のいずれかに該当する場合false、そうでない場合true<br/> 1.操作レベルが1(予約操作不可)<br/> 2.操作レベルが2(旅程操作不可)<br/> 3.予約・購入状態が未発券、または発券済み
   */
  isEligibleToForward?: boolean;
  /**
   * 利用可否<br/> いずれの利用不可理由にも該当しない場合にtrue
   */
  isEligible?: boolean;
  /**
   * 利用不可理由<br/> notNhPnr：直営PNRでない<br/> callCenterCreated：以下のいずれかに合致<br/> 1.国際旅程、かつPNRオーナーオフィスコードが、オフィスマスタに登録されているWebオフィスではない<br/> 2.日本国内単独旅程、かつPNRオーナーオフィスコードが、オフィスマスタに登録されているWebオフィスではない、第1便の出発日が設定ファイルに定義したDCS移行開始日付より前<br/> ndcPnr：NDC PNR<br/> needMedicalSupport：日本国内単独旅程かつ操作オフィスのPOSがアメリカ以外で、SSR MEDA、STCR、DPNAのいずれかが存在（医療系サポートが必要）<br/> hasInfantAndNeedSupport：日本国内単独旅程かつ操作オフィスのPOSがアメリカ以外で、SSR WCHC、SSR CKIN EXMO、SK EXMOのいずれかが存在し、かつ席あり、席なしを問わず幼児が存在する<br/> segmentNotConfirmed：セグメントステータスが確定ステータス(設定ファイルにて管理)以外である便が含まれる<br/> hasOpenSegment：OPEN便が含まれる<br/> offlineRemark：RMエレメントにWEB発券不可を示す所定の文字列(設定ファイルにて管理。)が存在する<br/> alreadyPurchased：購入・発券状態が未購入でない<br/> notKeepMyFareRevenuePnr：特典PNR区分がfalseで、Keep My FareのEMDが存在しない<br/> cannotLinkToMinds：特典PNR区分がtrueで、登録済みの種別FQTRのFFP情報にMINDS連携不可イレギュラー認識(NOMINDS、AFANOMINDS ※設定ファイルに定義)が存在する<br/> incorrectLoggedInUser：特典PNR区分がtrueで、PNRに登録済みの会員情報とログイン中の会員情報が一致しない、またはAMC会員でない<br/> passedTicketIssuanceDeadline：発券期限切れ<br/>  ※以下のいずれかが現在時間より前の場合に、発券期限切れとする。<br/>  1.DxAPIから取得したOPC<br/>  2.DxAPIから取得したTSTのLTD<br/>  3.国際旅程、または設定ファイルに定義したDCS移行開始日付より前の日本国内単独旅程の場合、DxAPIから取得した旅程内の第1セグメントの出発時刻(STD)ー6時間<br/>  4. 設定ファイルに定義したDCS移行開始日付以降の日本国内単独旅程の場合、条件に応じてDxAPIから取得した旅程内の第1セグメントの出発時刻(STD)がいずれかの条件を満たす場合、<br/>  4.1 設定ファイルに定義した空席待ちステータスの便を1便でも含む場合かつ、24時間以内の場合<br/>  4.2 Peach運航便(コードシェア便)を1便でも含む場合かつ、3時間以内の場合<br/>  4.3 上記以外の場合かつ、20分以内の場合<br/>   ※DxAPIから返却されるセグメントの出発時刻は、その空港のタイムゾーンの時刻となっているため、操作オフィスのPOSの現在時刻と比較をする際はタイムゾーンを考慮した時刻換算を行って比較を行う。空港ごとの時差はASWDBより取得する。
   */
  nonEligibilityReasons?: Array<GetOrderResponseDataOrderEligibilitiesPayment.NonEligibilityReasonsEnum>;
  /**
   * ウェルネット決済利用可否<br/> 以下の全ての条件を満たす場合true<br/> 1.操作オフィスのPOSが日本。<br/> 2.ご紹介ねっと利用予約ではない。<br/> ※S2パーソナライズ情報のご紹介ねっと経由識別にて判定する<br/> 3.総額情報内のサービス金額情報が0である。<br/> 4.払込期限が、操作日時 + ウェルネット用支払猶予時間より後である。<br/>   ※払込期限 > (操作日時+ウェルネット用支払猶予時間)<br/>   ※ウェルネット用支払猶予時間は設定ファイルから取得し、日本国内単独旅程とそれ以外で別の設定値とする。<br/>   ※払込期限は、以下のうち最も早いものを払込期限とする。<br/>   4-1.OPCもしくは日本の現在日時 + ウェルネット用発券期限延長時間のうち、遅い時間<br/>     ※ウェルネット用発券期限延長時間は設定ファイルから取得する。<br/>   4-2.DxAPIから返却されたLast Ticketing Date(LTD)の23:59:59。<br/>   4-3.第1便の最終発券期限<br/>     ※最終発券期限は出発何時間前とするかは設定ファイルから取得する。<br/>     ※出発日時は日本時間に換算して判定する。<br/> 5.以下のいずれかに合致する。<br/>   5-1.旅程区分がinternationalで、かつNHグループ販売便であるか、NHグループ運航便であるかのどちらかがfalseであるセグメントが存在しない<br/>   5-2.旅程区分がdomesticで、かつかつNHグループ販売便であるかがfalseであるセグメントが存在しない<br/> 6.購入の利用可否がtrueである。
   */
  isWellnetPaymentEligible?: boolean;
  /**
   * ANA Biz承認可否<br/> 以下の全ての条件を満たす場合true<br/> 1.ANA BizPNR区分がtrue<br/> 2.ANA Bizログインユーザ情報の権限情報.ロールリストに承認者の権限が含まれる。<br/> 3.以下のいずれかを満たす。<br/> 3.1 発券状況区分が「発券要求中」の発券要求の承認者が、ANA Bizログインユーザ情報のユーザIDと一致する<br/> 3.2 ANA Bizログインユーザ情報の管理ユーザ情報の承認対象企業精算CD(組織)が値なし(全体承認権限を保持している)、かつ企業情報(C票)の他組織閲覧制限が「制限しない」である<br/> 3.3 ANA Bizログインユーザ情報の管理ユーザ情報の承認対象企業精算CDと、かつ最新の企業情報(C票)の企業精算CDが一致する<br/> 4.ANA Bizログインユーザ情報の企業情報(A票)のイントラネット接続限定フラグが「限定しない」、<br/> または(企業情報(A票)のイントラネット接続限定フラグが「限定する」、かつANA Bizのログインユーザ情報がシームレスログイン)
   */
  isAnaBizApprovalEligible?: boolean;
  /**
   * 予約のみ利用可否<br/> 以下の全ての条件を満たす場合true<br/> 1. 第1便の出発日が設定ファイルに定義したDCS移行開始日付以降<br/> 2. 日本国内単独旅程である<br/> 3. 第1便の出発日時まで24時間以上ある、または以下全てを満たす<br/> 3-1. ANA Bizログイン済み<br/> 3-2. ANA Bizログイン情報の認証情報の企業情報(契約形態がパーチェシング(\"P\")の場合は企業情報(A票)、そうでない場合は企業精算情報(C票))の発券要求機能使用が「利用する」<br/> 3-3. ANA Bizログイン情報の認証情報のロールリストに出張者を含む
   */
  isOnholdEligible?: boolean;
}
export namespace GetOrderResponseDataOrderEligibilitiesPayment {
  export type NonEligibilityReasonsEnum =
    | 'notNhPnr'
    | 'callCenterCreated'
    | 'ndcPnr'
    | 'needMedicalSupport'
    | 'hasInfantAndNeedSupport'
    | 'segmentNotConfirmed'
    | 'hasOpenSegment'
    | 'offlineRemark'
    | 'alreadyPurchased'
    | 'notKeepMyFareRevenuePnr'
    | 'cannotLinkToMinds'
    | 'incorrectLoggedInUser'
    | 'passedTicketIssuanceDeadline';
  export const NonEligibilityReasonsEnum = {
    NotNhPnr: 'notNhPnr' as NonEligibilityReasonsEnum,
    CallCenterCreated: 'callCenterCreated' as NonEligibilityReasonsEnum,
    NdcPnr: 'ndcPnr' as NonEligibilityReasonsEnum,
    NeedMedicalSupport: 'needMedicalSupport' as NonEligibilityReasonsEnum,
    HasInfantAndNeedSupport: 'hasInfantAndNeedSupport' as NonEligibilityReasonsEnum,
    SegmentNotConfirmed: 'segmentNotConfirmed' as NonEligibilityReasonsEnum,
    HasOpenSegment: 'hasOpenSegment' as NonEligibilityReasonsEnum,
    OfflineRemark: 'offlineRemark' as NonEligibilityReasonsEnum,
    AlreadyPurchased: 'alreadyPurchased' as NonEligibilityReasonsEnum,
    NotKeepMyFareRevenuePnr: 'notKeepMyFareRevenuePnr' as NonEligibilityReasonsEnum,
    CannotLinkToMinds: 'cannotLinkToMinds' as NonEligibilityReasonsEnum,
    IncorrectLoggedInUser: 'incorrectLoggedInUser' as NonEligibilityReasonsEnum,
    PassedTicketIssuanceDeadline: 'passedTicketIssuanceDeadline' as NonEligibilityReasonsEnum,
  };
}
